
import { css } from 'lit';
export default css`
.lightbox__modal {
    display: none;
  }

`;